module.exports = __webpack_public_path__ + "img/02.a5a2e3e9.png";